import { Router } from "@angular/router";
import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";

import { SoundEnum } from "src/app/enums/sound.enum";
import { SnackBarService } from "../../../../services/common/snackBar.service";
import { CountdownComponent } from "ngx-countdown";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { IRegistrationConfirrm } from "src/app/interfaces/registrationConfirm";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-user-activation",
  templateUrl: "./user-activation.component.html",
  styleUrls: ["./user-activation.component.css"],
  providers: [ErrorsService]
})
export class UserActivationComponent implements OnInit {
  form: FormGroup;
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  confCode: boolean = true;
  timer: number = 60000;
  CellPhoneNumber: string;
  hideActiveCode: boolean = true;
  timeoutSession: boolean = true;
  codemask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  @ViewChild("countdown") counter: CountdownComponent;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private titleService: Title,
    private accountService: AccountService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(environment.siteTitle);
    this.form = this.fb.group({
      NationalCode: [null],
      ActivateCode: [null, Validators.compose([Validators.required])]
    });
  }

  demanCode(element: string) {
    this.errors = new Array();
    if (this.isEmptyOrSpaces(element)) {
      this.snackBar.OpenSnackBar(
        this.translate.get("require.nationalCode"),
        "ok",
        3000,
        SoundEnum.beep
      );
    } else {
      var data = {
        NationalCode: element
      };
      this.accountService.resendCode(data).subscribe(
        res => {
          this.timer = res.returnValue * 60;
          this.form.patchValue({
            CellPhoneNumber: res.returnValue2
          });
          this.confCode = false;
          this.hideActiveCode = false;
          this.counter.restart();
          this.snackBar.OpenSnackBar(
            this.translate.get("success.confirmationCodeHasBeenSent"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }

  resetTimer() {
    this.counter.restart();
  }

  onFinished() {
    this.timeoutSession = false;
  }

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  submit(form: IRegistrationConfirrm) {
    this.errors = new Array();
    this.accountService.confirm(form).subscribe(
      () => {
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
        this.router.navigate(["login"]);
      },
      error => {
        // this.errObject = this.errorService.getError(error);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(error);
        this.errorList = this.errorService.getErrorList(error.error);
      }
    );
  }
}
